(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6080],{

/***/ 9019:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/user-button",
      function () {
        return __webpack_require__(90077);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ ClerkComponentsTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/sanity/sane-image.tsx
var sane_image = __webpack_require__(27013);
;// CONCATENATED MODULE: ./components/common/clerk-components/hero.tsx



const ClerkComponentsHero = (param)=>/*#__PURE__*/ {
    let { heroTitle , heroDesc , heroImage  } = param;
    return (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex flex-col items-center px-4 py-12 mx-auto overflow-hidden max-w-7xl sm:px-6 lg:pt-16 lg:pb-24 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-2 text-base font-semibold leading-6 tracking-wide uppercase text-clerk-blue",
                    children: "Clerk Component"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-4xl font-extrabold leading-10 tracking-tight text-center text-gray-900 ",
                    children: heroTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-8 tracking-normal block max-w-[460px] text-lg font-normal leading-7 text-center text-gray-500 mb-12",
                    children: heroDesc
                }),
                heroImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                    wrapClassName: "drop-shadow-clerk-components filter",
                    className: "rounded-3xl",
                    src: heroImage
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/common/clerk-components/feature.tsx
var clerk_components_feature = __webpack_require__(23460);
;// CONCATENATED MODULE: ./components/clerk-components/template.tsx



const ClerkComponentsTemplate = (param)=>{
    let { image , text , json  } = param;
    var ref;
    const featureImages = Object.entries(image).filter((param)=>{
        let [key] = param;
        return key.includes("featureImage");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClerkComponentsHero, {
                heroTitle: text.heroTitle,
                heroDesc: text.heroDesc,
                heroImage: image.heroImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col px-6 py-24 mx-auto max-w-7xl gap-y-12 lg:gap-y-24",
                children: (ref = json.features) === null || ref === void 0 ? void 0 : ref.map((feature, index)=>{
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(clerk_components_feature/* ClerkComponentsFeature */.N, {
                        ...feature,
                        image: (ref = featureImages[index]) === null || ref === void 0 ? void 0 : ref[1],
                        imagePosition: index % 2 === 0 ? "left" : "right"
                    }, feature.featureTitle);
                })
            })
        ]
    });
};


/***/ }),

/***/ 23460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ClerkComponentsFeature; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77248);
/* harmony import */ var _sanity_sane_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27013);







const ClerkComponentsFeature = (param)=>/*#__PURE__*/ {
    let { featureTitle , featureDesc , image , imageFileURL , items , imagePosition , bottomCta  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col gap-8 lg:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex-1 ", imagePosition === "left" && "lg:order-2"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "mb-3 text-2xl font-extrabold leading-9 tracking-tight text-gray-900 lg:text-3xl",
                            children: featureTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-10 text-base font-normal leading-6 text-gray-500",
                            children: featureDesc
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col gap-10",
                            children: items.map((param)=>/*#__PURE__*/ {
                                let { itemTitle , itemDesc , icon  } = param;
                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mr-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "flex items-center justify-center w-12 h-12 rounded-md bg-clerk-blue",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .DynamicHeroIcon */ .Y, {
                                                    icon: icon,
                                                    className: "w-5 h-5 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(!itemDesc && "flex items-center"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("text-lg font-medium leading-6 text-gray-900", itemDesc ? "mb-2" : "mb-0"),
                                                    children: itemTitle
                                                }),
                                                itemDesc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-base font-normal leading-6 text-gray-500",
                                                    dangerouslySetInnerHTML: {
                                                        __html: itemDesc
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }, itemTitle);
                            })
                        }),
                        bottomCta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-8",
                            children: [
                                bottomCta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mr-1 text-gray-500",
                                    children: bottomCta.description
                                }),
                                bottomCta.internalHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    legacyBehavior: true,
                                    href: bottomCta.internalHref,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "text-clerk-blue",
                                        children: [
                                            bottomCta.cta,
                                            bottomCta.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .DynamicHeroIcon */ .Y, {
                                                icon: bottomCta.icon,
                                                weight: "outline",
                                                className: "relative inline w-5 h-5 bottom-[1px]"
                                            })
                                        ]
                                    })
                                }),
                                bottomCta.externalHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: bottomCta.internalHref,
                                    target: "_blank",
                                    rel: "noopener",
                                    children: [
                                        bottomCta.cta,
                                        bottomCta.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_5__/* .DynamicHeroIcon */ .Y, {
                                            icon: bottomCta.icon,
                                            weight: "outline",
                                            className: "relative inline w-5 h-5 bottom-[1px]"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex-1",
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sanity_sane_image__WEBPACK_IMPORTED_MODULE_3__/* .SaneImage */ .Q, {
                            wrapClassName: "h-60 sm:h-80 md:h-96 lg:h-full",
                            className: "rounded-3xl",
                            src: image,
                            height: undefined,
                            width: undefined,
                            layout: "fill"
                        }),
                        imageFileURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-60 sm:h-80 md:h-96 lg:h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                className: "rounded-3xl",
                                src: imageFileURL,
                                alt: "dsg",
                                layout: "fill"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 77248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DynamicHeroIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83319);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2905);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92777);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9014);




const DynamicHeroIcon = (param)=>{
    let { icon , className ="" , weight ="solid"  } = param;
    // eslint-disable-next-line
    const Icon = // @ts-ignore
    weight === "solid" ? _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__[icon] : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__[icon];
    if (!icon || !Icon) {
        const FallbackIcon = weight === "solid" ? _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FallbackIcon, {
            "aria-hidden": "true",
            className: className
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            "aria-hidden": "true",
            className: className
        })
    });
};
DynamicHeroIcon.defaultProps = {
    className: undefined,
    weight: undefined
};


/***/ }),

/***/ 27013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SaneImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53822);



function SaneImage(param) {
    let { src , height , width , layout , wrapClassName , ...props } = param;
    const { dimensions , format  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .decodeAssetId */ .h9)(src.asset._ref);
    const url = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .urlForImage */ .iQ)(src.asset).url() || "";
    const newHeight = height ? height : width ? width / dimensions.width * dimensions.height : format === "svg" || src.lowresolution ? dimensions.height : dimensions.height / 2;
    const newWidth = width ? width : height ? height / dimensions.height * dimensions.width : format === "svg" || src.lowresolution ? dimensions.width : dimensions.width / 2;
    const customDimensions = layout ? {
        layout
    } : {
        height: newHeight,
        width: newWidth
    };
    return format === "gif" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: url,
        height: newHeight,
        width: newWidth,
        alt: src.alt
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: wrapClassName || "image-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            alt: src.alt,
            ...props,
            ...customDimensions,
            src: url
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SaneImage);


/***/ }),

/***/ 90077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _components_clerk_components_template__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(795);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (_components_clerk_components_template__WEBPACK_IMPORTED_MODULE_0__/* .ClerkComponentsTemplate */ .F);


/***/ }),

/***/ 77082:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function LinkIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (LinkIcon);

/***/ }),

/***/ 75426:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function CheckCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CheckCircleIcon);

/***/ }),

/***/ 45001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ExclamationCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExclamationCircleIcon);

/***/ }),

/***/ 33772:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ExclamationIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExclamationIcon);

/***/ }),

/***/ 71738:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function EyeIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 12a2 2 0 100-4 2 2 0 000 4z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (EyeIcon);

/***/ }),

/***/ 77481:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function EyeOffIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (EyeOffIcon);

/***/ }),

/***/ 79771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function InformationCircleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (InformationCircleIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2868,9774,2888,179], function() { return __webpack_exec__(9019); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);